import BuildIcon from '@mui/icons-material/Build';
import { useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { portalPaths } from '@provision/portal-routes';
import { useGroupRules, UserGroupRules } from 'src/graphql';
import { useGetDtoolsAuthDetails } from 'src/graphql/entities/integrations/dtools/hooks/use-get-dtools-auth-details';
import { DataImportItem } from 'src/pages/Settings/data-import/data-import-item';
import { DataImportProps } from 'src/pages/Settings/data-import/data-import.types';
import { Modals, useModalMethods } from 'src/store/modals';
import { useNavigateRoute } from 'src/utils/routing';

export const DtoolsDataImportItem = ({ sx, size }: DataImportProps) => {
  const theme = useTheme();
  const { dtoolsAuthDetails } = useGetDtoolsAuthDetails();
  const { showModal } = useModalMethods(Modals.ImportDtoolsProjects);
  const dtoolsAuthed = !!dtoolsAuthDetails?.id;
  const { navigate } = useNavigateRoute();

  const { checkValidity, loading: loadingGroupRules } = useGroupRules();
  const allowDToolsDataImport =
    !loadingGroupRules && checkValidity([UserGroupRules.AccessToDtoolsDataImport]);

  if (!allowDToolsDataImport) {
    return null;
  }

  return (
    <Grid size={size} sx={sx}>
      <DataImportItem
        onClick={
          dtoolsAuthed ? showModal : () => navigate(portalPaths.settings.integrations())
        }
        title="D-Tools Cloud"
        subTitle={dtoolsAuthed ? 'Connected' : 'Not Connected'}
        actionButtonText={dtoolsAuthed ? 'Import from D-Tools' : 'Go to Integrations'}
        actionButtonVariant={dtoolsAuthed ? 'contained' : 'outlined'}
        description="Import projects to automatically create sites, clients, and projects in ProVision."
        icon={<BuildIcon sx={{ color: theme.palette.custom.tertiary.tertiary60 }} />}
      />
    </Grid>
  );
};
